import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { __ } from '../../translations';
import { Button, CornerMarker, FontIcon, Lock as OriginalLock } from '@intigral/shared';
import { showUpgradedModal } from '../../store/reducers/generalConfigurationSlice';

//  FIXED: Create a wrapper for Lock to handle boolean relative prop
const Lock = (props) => {
    const { relative, ...otherProps } = props;
    const relativeString = relative === true ? 'true' : relative === false ? 'false' : relative;
    return <OriginalLock {...otherProps} relative={relativeString} />;
};

const LockIcon = (props) => {
    const dispatch = useDispatch();
    const { corner, inline, channel } = props;
    const openUpgrade = () => {
        if (!channel?.isPPV) {
            dispatch(showUpgradedModal(true));
        }
    };

    if (corner) return <CornerMarker icon="lock" size="auto" label={__('upgrade')} onClick={openUpgrade} />;

    if (inline)
        return (
            <Button primary social compact aria-label={__('upgrade')} onClick={openUpgrade}>
                <FontIcon name="lock-filled" size="smaller" md="smaller" />
            </Button>
        );

    return <Lock {...props} onClick={openUpgrade} />;
};

export default LockIcon;
